import React, { createContext, useContext, useState, useCallback } from 'react';

const LoginModalContext = createContext();

export const LoginModalProvider = ({ children }) => {
    const [open, setOpen] = useState(false);

    const openLoginModal = useCallback(() => setOpen(true), []);
    const closeLoginModal = useCallback(() => setOpen(false), []);

    return (
        <LoginModalContext.Provider value={{ open, openLoginModal, closeLoginModal }}>
            {children}
        </LoginModalContext.Provider>
    );
};

export const useLoginModal = () => {
    const context = useContext(LoginModalContext);
    if (!context) {
        throw new Error('useLoginModal must be used within a LoginModalProvider');
    }
    return context;
};
